<div class="card">
  <div class="card-body card-body-actions">
    <div class="d-flex pb-2">
      <ng-content></ng-content>
    </div>
  </div>
</div>
